import { useSelector } from "react-redux";

// selector for loggedIn User
export const getUser = (state: any) => state.persistedStore?.userData?.user;

// selector for loggedIn User
export const getAuthPopup = (state: any) => state.persistedStore?.userData?.showAuthPopup;

// selector for getting theme
export const getTheme = (state: any) =>
  state.persistedStore?.settings?.theme;

export const useSelectors = () => {
  return {
    user: useSelector((state) => getUser(state)),
    theme: useSelector((state) => getTheme(state)),
    authPopup: useSelector((state) => getAuthPopup(state)),
  };
};
